<template>
  <div id="app">
    <MapPanel
      id="sidePanel"
      :class="{ sidebarOpen }"
      :extent="[timeFilterLower.value, timeFilterUpper.value]"
      :data="store.selectedData"
      @clear-select="clearSelect"
      @select-data="selectData"
    />
    <div id="mapContent"
       :class="{ sidebarOpen }">
      <Map
      v-if="isLoaded"
        id="mapContainer"
        :data="store.filteredData"
        :selectedData="store.selectedData"
        @select-data="selectData"
        @clear-select="clearSelect"
      />
      <div id="timelinePanel">
        <LineChart
          id="chartContainer"
          :data="store.data"
          :extent="store.temporalExtent"
          :selectedData="store.selectedData"
        />
        <Loading @select-data="selectData"/>
        <TimeSlider
          id="sliderContainer"
          :extent="store.temporalExtent"
          :lowerFilter="timeFilterLower"
          :upperFilter="timeFilterUpper"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "./config";
import { triggerWindowResize } from "./lib/Utils"
import { DataStore } from "./stores/DataStore";
import { FilterGreaterThan, FilterLowerThan, FilterValues } from "./lib/Filter";
import Map from "./components/Map";
import MapPanel from "./components/MapPanel";
import LineChart from "./components/Graph";
import Loading from "./components/Loading";
import TimeSlider from './components/TimeSlider'

export default {
  name: "app",
  created() {
    this.store = new DataStore();
    this.store.addFilter(this.timeFilterLower);
    this.store.addFilter(this.timeFilterUpper);
    this.store.loadData(config.url, config.mappings).then(() => {
      let extent = this.store.temporalExtent;
      this.timeFilterLower.value = extent[0];
      this.timeFilterUpper.value = extent[1];
    });
  },
  data() {
    return {
      isLoaded: false,
      store: false,
      timeFilterLower: new FilterGreaterThan("date_from", new Date(1900, 0, 1)),
      timeFilterUpper: new FilterLowerThan("date_to", new Date(2000, 11, 31))
    };
  },
  components: {
    Map,
    MapPanel,
    LineChart,
    TimeSlider,
    Loading,
  },
  computed: {
    sidebarOpen: function() {
      return this.store.selectedData.length > 0;
    }
  },
  mounted(){
    this.setLoaded()
  },
  methods: {
    clearSelect() {
      this.store.clearSelect("coordinates");
      this.store.clearSelect("place_name");
      updateLayout()
    },
    clearFilter(field) {
      this.store.clearFilterForField(field);
    },
    setLoaded(){
      this.isLoaded = true;
    },
    selectData(params) {
      if (params.clear) {
        this.clearSelect();
      }
      this.store.addSelect(new FilterValues(params.field, params.conditions));
      updateLayout()
    }
  }
};

function updateLayout() {
  setTimeout(triggerWindowResize, 200) // HACK:  Workaround to trigger resize of slider component
}
</script>

<style lang="less">
body {
  margin: 0px;
  font-family: Helvetica, Verdana, sans-serif;
  font-size: 12px;
  overflow: hidden;
}

#app {
  display: flex;
  width: 100vw;
  height: 100vh;

  #mapContent {
    display: flex;
    flex-direction: column;

    width: 100%;
    &.sidebarOpen {
      width:80%;
    }

    #mapContainer {
      overflow: hidden;
    }

    #timelinePanel {
      position: relative;
      height: 20rem;
      #chartContainer {
        position: absolute;;
        top:0;
        width: 99%;
        height: 90%;
      }
      #sliderContainer {
        position: absolute;
        bottom: 0;
        width: 99%;
      }
    }
  }

  #sidePanel {
    width:10%;
    overflow: hidden;
    &.sidebarOpen {
      overflow-y: scroll;
      width:20%;
    }
  }
}


</style>
